import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useState, useRef } from 'react';
import UserOnglet from "../../user/UserOnglet";
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicPwd = () => {
  const { setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);

  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { label: topic.title, link: topic.link},
  ];

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous rencontrez des difficultés pour vous connecter ? Vous avez oublié votre mot de passe ? Ce sont des choses qui arrivent. 
              Découvrez comment réinitialiser ou modifier votre mot de passe.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <p className="help-subtitle-part">Réinitialiser votre mot de passe sur ordinateur</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">Cliquez sur<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/forgot-pwd`}>Mot de passe oublié.</a></p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Saisissez l'adresse e-mail associée à votre compte.</p></li>
                      <li className="pl-8 mb-0"><p className="help-text">Cliquez sur <strong>Envoyer le lien de réinitialisation</strong>.</p></li>
                    </ol>
                    <p className="help-text">Vous recevrez par e-mail un lien pour réinitialiser votre mot de passe.</p>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Réinitialiser votre mot de passe sur navigateur mobile</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">Appuyer sur<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/forgot-pwd`}>Mot de passe oublié.</a></p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Saisissez l'adresse e-mail associée à votre compte.</p></li>
                      <li className="pl-8 mb-0"><p className="help-text">Appuyer sur <strong>Envoyer le lien de réinitialisation</strong>.</p></li>
                    </ol>
                    <p className="help-text">Vous recevrez par e-mail un lien pour réinitialiser votre mot de passe.</p>
                  </div>
              }
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <p className="help-text">
                Si vous avez demandé un lien de réinitialisation plusieurs fois, vérifiez que vous utilisez la bonne adresse e-mail. 
                Si vous ne savez pas quelle adresse e-mail vous avez utilisée, essayez de rechercher des anciens messages Wodzone dans votre boîte de réception. 
                Si vous n'en trouvez pas, vous devrez peut-être essayer avec une autre adresse e-mail.
              </p>
              <p className="help-text">
                Il se peut également que vous deviez désactiver l'aperçu des liens dans votre outil de messagerie (par exemple : Outlook) 
                ou la fonctionnalité d'analyse des e-mails, qui peuvent rendre un lien obsolète avant même qu'il ne soit ouvert.
                <br/>Pensez également à jeter un coup du côté des e-mails indésirables.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part mb-8">{anchorsParts[2].content}</p>
              <p className="help-text">Si vous connaissez votre mot de passe actuel et que vous souhaitez le modifier, voici comment procéder :</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <p className="help-subtitle-part">Réinitialiser votre mot de passe sur ordinateur</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur <strong>Profil</strong> {'>'} <strong>Compte</strong> {'>'}
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/loggin-settings`}>Connexion et sécurité.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">À côté de <strong>Mot de passe</strong>, cliquez sur <strong>Modifier</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Saisissez votre mot de passe actuel.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Saisissez et confirmez votre nouveau mot de passe.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Cliquez sur <strong>Mettre à jour le mot de passe</strong>.</p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Réinitialiser votre mot de passe sur ordinateur</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyez sur <strong>Menu</strong> {'>'} <strong>Compte</strong> {'>'}
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/loggin-settings`}>Connexion et sécurité.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">À côté de <strong>Mot de passe</strong>, appuyez sur <strong>Modifier</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Saisissez votre mot de passe actuel.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Saisissez et confirmez votre nouveau mot de passe.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyez sur <strong>Mettre à jour le mot de passe</strong>.</p></li>
                    </ol>
                  </div>
              }
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicPwd